import type { TFunction } from "i18next";

const FIELD_LABEL_KEYS: Record<string, string> = {
  "transport.transport_type": "bookingWizard.transportDetails.transportType",
  "transport.booking_type": "bookingWizardV2.details.fieldLabels.bookingType",
  "transport.service_level": "bookingWizard.transportDetails.serviceLevel",
  "transport.booking_incoterm": "bookingWizard.transportDetails.incoterm",
  "transport.origin_pickup_date": "bookingWizardV2.details.fieldLabels.cargoReadyDate",
  "supplier.name": "bookingWizard.supplierDetails.supplierName",
  "supplier.email": "bookingWizardV2.details.fieldLabels.supplierEmail",
  "supplier.phone": "bookingWizardV2.details.fieldLabels.supplierPhone",
  "supplier.country": "bookingWizard.supplierDetails.country",
  "supplier.province": "bookingWizard.supplierDetails.province",
  "supplier.city": "bookingWizard.supplierDetails.city",
  "supplier.address": "bookingWizard.supplierDetails.address",
  products: "bookingWizard.steps.productDetails",
};

const PRODUCT_FIELD_LABEL_KEYS: Record<string, string> = {
  hs_code: "bookingWizardV2.details.fieldLabels.hsCode",
  gross_weight: "bookingWizardV2.details.fieldLabels.grossWeight",
  cbm: "bookingWizardV2.details.fieldLabels.cbm",
  value: "bookingWizardV2.details.fieldLabels.value",
};

export const fieldKeyToDomId = (fieldKey: string): string =>
  `field-${fieldKey.replace(/\./g, "-")}`;

export const scrollToField = (fieldKey: string): void => {
  document.getElementById(fieldKeyToDomId(fieldKey))?.scrollIntoView({
    behavior: "smooth",
    block: "center",
  });
};

export const getMissingFieldLabel = (
  fieldKey: string,
  t: TFunction
): string => {
  const mapped = FIELD_LABEL_KEYS[fieldKey];
  if (mapped) return t(mapped);

  if (fieldKey === "products") {
    return t("bookingWizard.steps.productDetails");
  }

  const productMatch = fieldKey.match(/^products\.(\d+)\.(\w+)$/);
  if (productMatch) {
    const [, index, field] = productMatch;
    const fieldKeyPath = PRODUCT_FIELD_LABEL_KEYS[field];
    const fieldLabel = fieldKeyPath
      ? t(fieldKeyPath)
      : t(`bookingWizardV2.draftPreview.productFields.${field}`, field);
    return t("bookingWizardV2.details.productFieldChip", {
      index: Number(index) + 1,
      field: fieldLabel,
    });
  }

  return fieldKey;
};
